module.exports = __webpack_public_path__ + "static/media/market.3394351a.png";